/**
 * Gets the currently active admin page
 *
 * @param {Object} state - Redux state
 * @return {string} The key of the active page
 */
export function getActivePage(state) {
	return state?.activePage || 'settings';
}
